import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const StopWatch = ({ isRunning, timeElapsed }) => {
  // state to store time
  const [time, setTime] = useState(timeElapsed);
  useEffect(() => {
    let intervalId;
    if (isRunning) {
      // setting time from 0 to 1 every 10 milisecond using javascript setInterval method
      intervalId = setInterval(() => setTime(time + 1), 10);
    }
    return () => clearInterval(intervalId);
  }, [isRunning, time]);

  // Hours calculation
  const hours = Math.floor(time / 360000);

  // Minutes calculation
  const minutes = Math.floor((time % 360000) / 6000);

  // Seconds calculation
  const seconds = Math.floor((time % 6000) / 100);

  return (
    <Fragment>
      {hours?.toString().padStart(2, '0')}
      :
      {minutes.toString().padStart(2, '0')}
      :
      {seconds.toString().padStart(2, '0')}
    </Fragment>
  );
};

const mapStateToProps = ({}) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

StopWatch.propTypes = {
  isRunning: PropTypes.bool,
  timeElapsed: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StopWatch));
